// @flow

import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { withStyles } from '@material-ui/core/styles';

import { IMAGE_PATH, isProd } from '../util/config';

const logoPath = `${IMAGE_PATH}/logo/team-engine-logo-with-name-white.png`;

const styles = (theme) => ({
  toolBar: {
    minHeight: 0,
    padding: '5px 10px',
  },
  appBar: {
    backgroundColor: isProd ? theme.palette.primary[700] : theme.palette.secondary[900],
  },
  link: {
    textDecoration: 'none',
  },
});

type Props = {
  classes: Object,
}

const Nav = (props: Props) => {
  const { classes } = props;
  return (
    <AppBar className={classes.appBar}>
      <Toolbar className={classes.toolBar}>
        <img src={logoPath} height="30" alt="Home" />
      </Toolbar>
    </AppBar>
  );
};

export default withStyles(styles)(Nav);
